import { createSelector } from '@ngrx/store';
import * as fromApp from '../app.reducer';
import * as fromAuth from '../reducers/auth.reducer';

export const selectStoreState = createSelector(
  fromApp.selectAppState,
  (state: fromApp.AppState) => state.store
);
export const selectAuthStateLoaded = createSelector(
  selectStoreState,
  (state) => state.authStateLoaded
);

export const selectAuthStateLoadingError = createSelector(
  selectStoreState,
  (state) => state.authStateError
);
